import React from 'react';
import { QuestionType } from '../../../../../lib/SkillComponents/QuestionComponentValues';
import BlankQuestionViewer from './BlankQuestionViewer';
import BooleanQuestionViewer from './BooleanQuestionViewer';
import CheckboxQuestionViewer from './CheckboxQuestionViewer';
import ChoiceQuestionViewer from './ChoiceQuestionViewer';
import MatchQuestionViewer from './MatchQuestionViewer';
import OrderQuestionViewer from './OrderQuestionViewer';
import PollQuestionViewer from './PollQuestionViewer';
const QuestionFactory = (props) => {
    var _a;
    switch ((_a = props === null || props === void 0 ? void 0 : props.componentValues) === null || _a === void 0 ? void 0 : _a.questionType) {
        case QuestionType.Blank:
            return React.createElement(BlankQuestionViewer, Object.assign({}, props));
        case QuestionType.Boolean:
            return React.createElement(BooleanQuestionViewer, Object.assign({}, props));
        case QuestionType.Checkbox:
            return React.createElement(CheckboxQuestionViewer, Object.assign({}, props));
        case QuestionType.Choice:
            return React.createElement(ChoiceQuestionViewer, Object.assign({}, props));
        case QuestionType.Match:
            return React.createElement(MatchQuestionViewer, Object.assign({}, props));
        case QuestionType.Order:
            return React.createElement(OrderQuestionViewer, Object.assign({}, props));
        case QuestionType.Poll:
            return React.createElement(PollQuestionViewer, Object.assign({}, props));
        default:
            return null;
    }
};
export default QuestionFactory;
//# sourceMappingURL=QuestionFactory.js.map